<template>
  <div>
    <LabeledSelectionTile
      v-slot="{ tile }"
      v-model="selectedTypeId"
      :label="label || 'Orientation'"
      :options="options"
      :is-spacing-enabled="isSpacingEnabled"
    >
      <LeftArm v-if="tile.arm === 'left'" />
      <RightArm v-else-if="tile.arm === 'right'" />
      <span v-else>{{ tile.text }}</span>
    </LabeledSelectionTile>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import LabeledSelectionTile from '../../../components/common/LabeledSelectionTile';
import { useAvailability } from '../../../composables/useAvailability';
import LeftArm from './LeftArm';
import RightArm from './RightArm';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  isSpacingEnabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    /** @type import('vue').PropType<Number | null> */
    type: Number,
    default: null,
  },
  types: {
    /** @type import('vue').PropType<Type[]> */
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: null,
  },
});

const emits = defineEmits(['update:modelValue']);

const selectedTypeId = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emits('update:modelValue', newValue);
  },
});

function getArm(str) {
  if (str.includes('Left')) {
    return 'left';
  }
  if (str.includes('Right')) {
    return 'right';
  }
  return null;
}

const { type: availability } = useAvailability(props.id);

const options = computed(() => props.types.map((type) => {
  const data = {
    id: type.id,
    text: type.name,
    unavailable: !availability.value[type.id],
    arm: getArm(type.name),
  };
  // TODO temp work arounnd for 3v consolidated
  if (typeof type.available === 'boolean') {
    data.unavailable = !type.available;
  }
  return data;
}));
</script>
